var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52925 5.52861C5.7896 5.26826 6.21171 5.26826 6.47206 5.52861L10.0006 9.0572L13.5292 5.52861C13.7896 5.26826 14.2117 5.26826 14.4721 5.52861C14.7324 5.78896 14.7324 6.21107 14.4721 6.47141L10.9435 10L14.4721 13.5286C14.7324 13.789 14.7324 14.2111 14.4721 14.4714C14.2117 14.7318 13.7896 14.7318 13.5292 14.4714L10.0006 10.9428L6.47206 14.4714C6.21171 14.7318 5.7896 14.7318 5.52925 14.4714C5.2689 14.2111 5.2689 13.789 5.52925 13.5286L9.05784 10L5.52925 6.47141C5.2689 6.21107 5.2689 5.78896 5.52925 5.52861Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ec9b9ded73d10bc608cdb10fbc472d20.svg";
export { ForwardRef as ReactComponent };